export function removeUrlParameter(url: string, parameter: string) {
    let startIndex = url.indexOf(parameter);
    if (startIndex > 0) {
        let endIndex;

        for (let i = startIndex + parameter.length + 1; i < url.length && !endIndex; i++) {
            // <?|&><parameter>=<value>[&]
            if (url.charAt(i) === '&') {
                endIndex = i + 1;
            }
        }

        if (!endIndex) {
            startIndex--; // last parameter on the URL and no need to maintain the '&' character
        }

        const substring = url.substring(startIndex, endIndex);

        return url.replace(substring, '');
    }

    return url;
}
